import { useEffect, useState } from 'react';
import RootLayout from 'layouts/RootLayout';
import { useNavigate, useParams } from 'react-router-dom';

const INVITE_URL = process.env.REACT_APP_INVITE_URL;

const LineJoin = () => {
  const [inviteData, setInviteData] = useState(null);
  const navigate = useNavigate();
  const { uuid } = useParams();

  useEffect(() => {

    const fetchInviteData = async () => {
      try {
        const response = await fetch(`${INVITE_URL}/join/${uuid}`);
        if (response.ok) {
          const data = await response.json();
          setInviteData(data);
        } else {
          alert('抱歉您的邀請連結有誤!!');
          window.location.href = 'https://klbaby.gocare.tw/clinicList';
        }
      } catch (error) {
        console.error('取得 邀請連結 資料時出錯：', error);
        alert('抱歉您的邀請連結有誤!!');
        window.location.href = 'https://klbaby.gocare.tw/clinicList';
      }
    };

    fetchInviteData();
  }, [uuid]);

  useEffect(() => {
    if (inviteData) {
      const lineJoinUrl = `https://lin.ee/mxPBb1r`;
      window.location.href = lineJoinUrl;
    }
  }, [inviteData, navigate]);

  return (
    <RootLayout title="加入好友">
      <div className="p-6 flex flex-col justify-center items-center">
        <img src="https://qr-official.line.me/gs/M_660mpyzp_GW.png?oat_content=qr" alt="LINE QR Code"/>
      </div>
    </RootLayout>
  );
};

export default LineJoin;